import type { ApiDto } from '@portals/shared/portal/ApiDto';

import type { ApiDetailedResponseEnvironmentRelease, ExternalApiResponse } from '@/openapi/schema';

/**
 * Union type that supports both old ApiDto and new ExternalApiResponse.
 * This allows components to work with both API response formats during migration.
 */
export type ApiItem = ApiDto | ExternalApiResponse;

/**
 * Helper to normalize classification to lowercase for consistent filtering/display.
 * - ExternalApiResponse: uppercase classification (e.g., "PUBLIC")
 * - ApiDto: lowercase classification (e.g., "public")
 */
export function getClassification(api: ApiItem): string {
  return api.classification.toLowerCase();
}

/**
 * Helper to normalize stage to lowercase for consistent filtering/display.
 * - ExternalApiResponse: uppercase stage (e.g., "LAUNCHED")
 * - ApiDto: lowercase stage (e.g., "launched")
 */
export function getStage(api: ApiItem): string {
  return api.stage.toLowerCase();
}

/**
 * Helper to get the product page URL.
 * - ExternalApiResponse: doesn't have this field, returns null
 * - ApiDto: uses productPageUrl
 */
export function getProductPageUrl(api: ApiItem): string | null {
  return 'productPageUrl' in api ? api.productPageUrl : null;
}

/**
 * Helper to get current releases.
 * - ExternalApiResponse: uses currentReleases array
 * - ApiDto: doesn't have this field, returns empty array
 */
export function getCurrentReleases(api: ApiItem): ApiDetailedResponseEnvironmentRelease[] {
  return 'currentReleases' in api ? api.currentReleases : [];
}
